import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import HorizontalScrollbar from './HorizontalScrollbar';
import Loader from './Loader';

const SimilarExercises = ({ targetMusclesExercises, equipmentExercises }) => {
  return (
    <Box sx={{ mt: { lg: '100px', xs: '0' } }}>
      
      {/* Target muscle exercises */}
      <Typography variant="h3" mb="33px">
        Exercises that target the same muscle group
      </Typography>

      <Stack direction="row" sx={{ p: 2, position: 'relative' }}>
        {targetMusclesExercises?.length ? (
          <HorizontalScrollbar
            data={targetMusclesExercises}
            isBodyParts={false}
          />
        ) : (
          <Loader />
        )}
      </Stack>

      {/* Equipment exercises */}
      <Typography variant="h3" mt="100px" mb="33px">
        Exercises that use the same equipment
      </Typography>

      <Stack direction="row" sx={{ p: 2, position: 'relative' }}>
        {equipmentExercises?.length ? (
          <HorizontalScrollbar
            data={equipmentExercises}
            isBodyParts={false}
          />
        ) : (
          <Loader />
        )}
      </Stack>

    </Box>
  );
};

export default SimilarExercises;
